import React from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import First from "./First";

const ContactUs = () => {
  return (
    <>
      <Header />
      <First />
      <Footer />
    </>
  );
};

export default ContactUs;
